import { useState } from "react";
import { isMasterOrSlave } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { getTyCodeFromState } from "../../../../shared-logic/utils/typedUtils";
import { useBnbSelector } from "../../redux/store";

type ConfigCodeType = {
    qrCode: string;
    code: string;
    link: string;
    showQr: boolean;
    showSaving: boolean;
    error: boolean;
    isMasterOrSlave: boolean;
    showPopup: () => void;
    hidePopup: () => void;
};

const useConfigCode = (): ConfigCodeType => {
    const save = useBnbSelector((state) => state.save);
    const masterOrSlave = useBnbSelector((state) => isMasterOrSlave(state.commonSettings));

    const [showQr, setShowQr] = useState<boolean>(false);

    const { saved, saving, error } = save;
    const { code, link } = getTyCodeFromState(save.data) || { code: "", link: "" };

    return {
        qrCode: save.qrCode,
        code,
        link,
        showQr,
        // also checking if data is already set as data can be invalidated without new save call
        showSaving: saving || (!saved && !saving && !code),
        error,
        isMasterOrSlave: masterOrSlave,
        showPopup: () => {
            setShowQr(true);
        },
        hidePopup: () => setShowQr(false),
    };
};

export default useConfigCode;
